import {
    getAllProvinces,
    getProvinceById,
    getWardById,
    getWardsByProvince
} from "./db";

export async function getAddress(provinceId, districtId, wardId)
{
    if (typeof provinceId == "undefined" || provinceId === 0 || provinceId === '') return '';

    let province = await getProvinceById(provinceId)

    if (!province?.fullname || province === undefined || wardId === null || wardId === '' || wardId === 0)
    {
        return province?.fullname ?? '';
    }

    let ward = await getWardById(wardId);

    if (!ward?.fullname || ward === undefined) return province?.fullname;

    return ward?.fullname + ', ' + province?.fullname;
}

export async function getProvinceOption()
{
    const provinces = await getAllProvinces();

    return [{
        value: 0,
        label: "Chọn tỉnh thành"
    }, ...provinces.map(province => ({
        value: province.id,
        label: province.name
    }))];
}

export async function getWardOptionByProvinceId(provinceId)
{
    const wards = await getWardsByProvince(parseInt(provinceId));

    return [{
        label: 'Chọn phường xã',
        value: 0
    }, ...wards.map(ward => ({
        value: ward.id,
        label: ward.name
    }))];
}

export async function provinceChange({value, setWardOptions, setValue})
{
    const wardOptions = await getWardOptionByProvinceId(value);

    setValue()

    setWardOptions(wardOptions);
}